// extracted by mini-css-extract-plugin
export default {"root":"Udweo","animator":"_1y_MF","notification-link":"oukIx","notificationLink":"oukIx"};